module.exports = __webpack_public_path__ + "img/liz.cba094f8.png";